
const Kumelenme = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Kümelenmeler</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>Türkiye’nin konularında lider olan firmaların iş birliklerini arttırmak amacıyla başta Güvenlik, Akıllı Şehir, Trafik, İletişim/Haberleşme/Bilgi Teknolojileri alanlarında olmak üzere kümelenmeler oluşturulmakta, çeşitli iş birliği geliştirme faaliyetleri yürütülmektedir.</p>
          <p>Çeşitli kamusal programlarla da desteklenen kümelenme programları kapsamında, uluslararasılaşma faaliyetlerini arttırmak, küme içi ve dışı iş birliklerini geliştirmek, sektörde sahip olunan birikimin artırılmasını, diğer sektörlere aktararak kaynakların doğru kullanılmasını ve yapılacak yeni yatırımların doğru planlanmasını sağlamak gibi temel amaçlar bulunmaktadır.</p>
        </div>
      </div>

      <div className="row justify-content-md-center">
        <div className="col-10">
          <ul>
            <li>Yönetici Şirket tarafından firma çalışanlarının eğitim ihtiyaçlarını karşılamak amacıyla ücretli ve ücretsiz kongre, seminer ve toplantılar düzenlenmektedir. </li>
            <li>Firmaların kendi aralarında ve uluslararası alanda iş birliklerini arttırmaya yönelik, proje pazarları, sektörel ticaret heyetleri, eşleştirme etkinlikleri, alım heyetleri, yurt dışı fuar katılımları ve çeşitli projeler gerçekleştirilmektedir. </li>
            <li>Bölgede yer alan firmaların; yürüttükleri projeler sürecinde karşılaştıkları sorunlara, teknolojik bir çözüm getirilmesi amacıyla Bölge içinde veya dışındaki firmalar, üniversiteler ya da diğer Ar-Ge kurum ve kuruluşları arasında koordinasyon faaliyeti yürütülmektedir. </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Kumelenme;
